import ModalLayout from '../../../layout/main/ModalLayout'
import { TABLET_SIZE } from '../../../../core/constants/common'
import { useWindowSize } from '../../../../core/hooks/common/useWindowSize'
import Text from '../../../../core/utils/Text'
import { useSetOwnerAccounts } from '../../../../core/services/react-query/setting/accounting'
import { ClipLoader } from 'react-spinners'
import CoinSelect from '../../../common/input/CoinSelect'
import { useEffect, useState } from 'react'
import { Background } from '../../../../styles/CommonStyles'
import Input from '../../../common/input/Input'
import { useAvailableCoins } from '../../../../core/services/react-query/setting'
import { deepCopy, uuidv4 } from '../../../../core/utils/common'

const OwnerAccountModal = ({ details, onClose, cache }) => {
	const { width } = useWindowSize()

	const initialInput = {
		currency: null,
		name: '',
		bankName: '',
		number: '',
		card: '',
		iban: '',
		swift: '',
		errorMessage: '',
		isError: false,
		errorKey: '',
	}
	const [input, setInput] = useState(initialInput)
	const onInputChange = (v, t) => {
		setInput((s) => ({ ...s, [t]: v }))
	}

	// const checkError = () => {
	// 	const keys = Object.keys(input)
	// 	for (let i = 0; i < keys.length; i++) {
	// 		const k = keys[i]
	// 		const v = input[k]
	// 		if (k === 'isError' || k === 'errorMessage' || k === 'errorKey') continue
	// 		if (!v) {
	// 			setInput((state) => ({
	// 				...state,
	// 				isError: true,
	// 				errorMessage: `${k}-is-required`,
	// 				errorKey: k,
	// 			}))
	// 			return false
	// 		}
	// 	}
	// 	return true
	// }

	// useEffect(() => {
	// 	if (input.isError && input[input.errorKey]) {
	// 		setInput((state) => ({ ...state, isError: false, errorMessage: '', errorKey: '' }))
	// 	}
	// }, [input])

	const { data: availableCoins } = useAvailableCoins()
	useEffect(() => {
		if (!!details?.data && !!availableCoins) {
			const currency = availableCoins.find((x) => x.id === details.data.currency)
			if (!!currency) {
				setInput({
					...details.data,
					currency,
				})
			}
		}
	}, [details, availableCoins])

	const { mutate: addAccount, isLoading } = useSetOwnerAccounts(onClose)
	const onAddAccount = () => {
		// check error is not needed here - temp
		const res = true
		if (res) {
			const isEdit = details?.type === 'edit'
			const newAccounts = deepCopy(cache?.accounts || [])
			const payload = {}
			const keys = Object.keys(input)
			for (const k of keys) {
				if (input[k]) {
					if (k === 'currency') payload[k] = input[k].id
					else payload[k] = input[k]
				}
			}

			if (isEdit) {
				newAccounts[details.idx] = payload
			} else {
				payload.id = uuidv4()
				newAccounts.push(payload)
			}

			addAccount({ accounts: newAccounts })
		}
	}

	useEffect(() => {
		const isEdit = details?.type === 'edit'
		const acc = details?.data
		if (isEdit) {
			let currency
			if (acc.currency === 'irt') {
				currency = { name: 'Tooman', fa: 'تومان', id: 'irt' }
			} else {
				currency = availableCoins?.find((x) => x.id === acc.currency)
			}
			setInput((s) => ({
				...s,
				...acc,
				currency,
			}))
		}
	}, [details, availableCoins])

	return (
		<ModalLayout open={details.show} width={'500px'} padding={'0'} isStatic={width > TABLET_SIZE}>
			<div className='relative dark:text-gray-300 text-sm'>
				<div className={'px-3 py-3 w-full rounded-t-md dark:bg-cardBg'}>
					<Text tid={`owner-account`} />
				</div>

				<div className={'flex flex-col gap-2 p-4'}>
					<div className='mx-1 flex flex-col'>
						<CoinSelect
							value={input.currency}
							onChange={(v) => onInputChange(v, 'currency')}
							bg={'mainBg'}
							width={'100%'}
							hasIrt
						/>

						{input.isError && input.errorKey === 'currency' ? (
							<div className={'px-2'}>
								<Text tid={input.errorMessage} className={'text-red-500 text-xs mt-[-8px]'} />
							</div>
						) : null}
					</div>

					{['name', 'bankName', 'number', 'card', 'iban', 'swift'].map((item, idx) => {
						return (
							<div className={`flex flex-col ${idx === 0 ? 'mt-4' : ''}`} key={item}>
								<Background bg={'mainBg'} className={'mt-[-4px]'}>
									<Input
										value={input[item]}
										label={item}
										onInputChange={(v) => onInputChange(v, item)}
										size={'small'}
										height={'40px'}
									/>
								</Background>
								{input.isError && input.errorKey === item ? (
									<Text
										tid={input.errorMessage}
										className={'text-red-500 text-xs mt-[-8px] px-3'}
									/>
								) : null}
							</div>
						)
					})}
				</div>

				<div className={'flex flex-col gap-3 px-5 mt-5 mb-3'}>
					<div
						className={`bg-active text-slate-800 font-semibold rounded-md h-[40px]
                        w-full cursor-pointer flex items-center justify-center gap-2
                            `}
						onClick={onAddAccount}
					>
						{isLoading ? <ClipLoader size={24} /> : null}
						<Text tid={`${details?.type}-owner-account`} />
					</div>

					<div
						className={`border-red-500 border-opacity-20 border-[1px] cursor-pointer
                            font-semibold rounded-md h-[40px] w-full flex items-center justify-center
                            `}
						onClick={onClose}
					>
						<Text tid={'cancel'} />
					</div>
				</div>
			</div>
		</ModalLayout>
	)
}

export default OwnerAccountModal
